<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2642_19060)">
    <rect x="1" y="1" width="18" height="18" rx="3" stroke="#E0E0E0" stroke-width="2"/>
    </g>
    <defs>
    <clipPath id="clip0_2642_19060">
    <rect width="20" height="20" fill="white"/>
    </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'UncheckedIcon',
};
</script>

<style>

</style>
